import styled from "@emotion/styled"

export const StyledMemberDsar = styled.div`
  .content-stack {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .section-card {
    border-radius: 14px;
  }

  .section-title {
    margin: 0 0 16px;
    font-size: 18px;
    font-weight: 700;
  }

  .form-grid,
  .filters {
    display: grid;
    grid-template-columns: minmax(220px, 1fr) minmax(160px, 220px) minmax(260px, 2fr) auto;
    gap: 12px;
    align-items: flex-start;
    margin-bottom: 16px;
  }

  .filters {
    grid-template-columns: minmax(220px, 1fr) 180px auto;
    align-items: center;
  }

  .row-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;
  }

  .table-empty,
  .page-empty {
    color: var(--cms-text-secondary);
    padding: 24px;
    text-align: center;
  }

  .pagination-section {
    display: flex;
    justify-content: center;
    padding: 12px 0;
  }

  .detail-stack {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  pre {
    max-width: 100%;
    overflow: auto;
    padding: 10px;
    border-radius: 8px;
    background: var(--cms-surface-muted);
    font-size: 12px;
    white-space: pre-wrap;
  }
`
